$( document ).ready(function() {
  localStorage.setItem('single_id', '');
  localStorage.setItem('second_d', '');
  localStorage.setItem('first', '');
});
$(document).on('click', '.quick-add-to-cart-button.single_ls_btn', function() {
     localStorage.setItem('second_d', '');
     localStorage.setItem('first', '');
    var id = $(this).find('form').find('input.quick-add-id').val();
    localStorage.setItem('single_id', id);
});
$(document).on('click', 'button.coll-cart-add.add-to-cart', function() {
    var quty = $(this).siblings('product-quantity.product-quantity').find('.product-quantity__selector').val();
    localStorage.setItem('quty', quty);
});


$(document).on('click', '.product-item__quick-buy.variant_pro', function() {
    localStorage.setItem('single_id', '');
    setTimeout(function() {
    localStorage.setItem('second_d', '');
    var name = $('.main_modal.active .main_coll .product-variants--radio .product-variant__item input:checked+label').attr('attr');
       $('.main_modal.active span.opt_name').text(':- '+name);
        var price = parseFloat($('.main_modal.active .modal-content .price_code .orig_price').attr('price_main')) || 0; 
           $('.main_modal.active .main_data_coll').attr('priceupdate',price);
      $(".main_modal.active .custom-products").each(function() {
        var title = $(this).attr('data_coll');
        if (name === title) {
            $(this).show();
            $(this).addClass('selected_items_custom');
        } else {
            $(this).hide();
            $(this).removeClass('selected_items_custom');
        }
    });
   $('.selected_tm').removeClass('selected_tm');
    var selectedItems = $('.selected_items_custom');
    if (selectedItems.length > 0) {
        //selectedItems.first().toggleClass('selected_tm');
    }
     var selectedTmElement = $('.main_modal.active .main_coll .selected_tm');
        var price2 = parseFloat(selectedTmElement.attr('varprice')) || 0; 
         var id = $('.main_modal.active .main_coll .selected_tm').attr('varid');
        $('.main_modal.active .second_id_coll').val(id);
           if(id){
           localStorage.setItem('second_d', id);
           }else{
            localStorage.setItem('second_d', '');
          }
        var totalPrice = price + price2;
        var formattedCheck = (totalPrice / 100).toFixed(2);
          var formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'AED',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
    var formattedCurrency = formatter.format(formattedCheck);
    formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
    var displayText = `${formattedCurrency}`;
    $('.main_modal.active .modal-content .price_code .orig_price').text(displayText);

$(document).on('click', '.main_modal.active .custom-products', function() {
    $(this).toggleClass('selected_tm');
    $(this).siblings().removeClass('selected_tm');
    var id = $(this).attr('varid');
    var id1 = $('.main_modal.active product-form input.first_id_coll').val()
     if(id1){
     localStorage.setItem('first', id1);
     }else{
      localStorage.setItem('first', '');
      }
       if ($(this).hasClass("selected_tm")) {
    $('.main_modal.active .second_id_coll').val(id);
    localStorage.setItem('second_d', id);
    var price = parseFloat($('.main_modal.active .main_data_coll').attr('priceupdate')) || 0;
    var price2 = parseFloat($(this).attr('varprice')) || 0;
    var totalPrice = price + price2;
    var formattedCheck = (totalPrice / 100).toFixed(2);
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'AED',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    var formattedCurrency = formatter.format(formattedCheck);
    formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
    var displayText = `${formattedCurrency}`;
     $('.main_modal.active .modal-content .price_code .orig_price').text(displayText);
    }else{
      localStorage.setItem('second_d', '');
      $('.main_modal.active .second_id_coll').val('');
        localStorage.setItem('other_single_id', '');
      var totalPrice =  $('.main_modal.active .main_data_coll').attr('priceupdate');
       var formattedCheck = (totalPrice / 100).toFixed(2);
       var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'AED',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      var formattedCurrency = formatter.format(formattedCheck);
      formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
      var displayText = `${formattedCurrency}`;
       $('.main_modal.active .modal-content .price_code .orig_price').text(displayText);
      }
});
document.querySelector('product-variants').addEventListener('change', function() {
   var variantElement = document.querySelector('product-variants');
    var name = variantElement.currentVariant.title;
  $('.main_modal.active span.opt_name').text(':- '+name);
    var price = parseFloat(variantElement.currentVariant.price) || 0; 
      $('.main_modal.active .main_data_coll').attr('priceupdate',price);
    $(".main_modal.active .custom-products").each(function() {
        var title = $(this).attr('data_coll');
        if (name === title) {
            $(this).show();
            $(this).addClass('selected_items_custom');
        } else {
            $(this).hide();
            $(this).removeClass('selected_items_custom');
        }
    });
    $('.main_modal.active .selected_tm').removeClass('selected_tm');
    
    var selectedItems = $('.main_modal.active .selected_items_custom');
    if (selectedItems.length > 0) {
        selectedItems.first().toggleClass('selected_tm');
    }
        var selectedTmElement = $('.main_modal.active .selected_tm');
        var id = $(selectedTmElement).attr('varid');
        var id1 = $('.main_modal.active product-form input.first_id_coll').val()
         if(id1){
         localStorage.setItem('first', id1);
         }else{
             localStorage.setItem('first', '');
          }
         $('.main_modal.active .second_id_coll').val(id);
         if(id){
         localStorage.setItem('second_d', id);
         }else{
         localStorage.setItem('second_d', '');
         }
        var price2 = parseFloat(selectedTmElement.attr('varprice')) || 0; 
        var totalPrice = price + price2;
        var formattedCheck = (totalPrice / 100).toFixed(2);
            var formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'AED',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
        var formattedCurrency = formatter.format(formattedCheck);
        formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
        var displayText = `${formattedCurrency}`;
        $('.main_modal.active .modal-content .price_code .orig_price').text(displayText);
});
        var idm = $('.custom-products.selected_items_custom.selected_tm').attr('varid');
         if(id){
         localStorage.setItem('second_d', idm);
         }else{
         localStorage.setItem('second_d', '');
         }
        var id1 = $('.main_modal.active product-form input.first_id_coll').val()
         if(id1){
         localStorage.setItem('first', id1);
         }else{
             localStorage.setItem('first', '');
          }
      
    }, 1500);
});
